// src/components/layout/TopBar.jsx
import React from "react";

export default function TopBar({ tab, onSwitch }) {
  return (
    <header className="topbar">
      <div className="brand">
        <img
          src={`${process.env.PUBLIC_URL}/Icon.svg`}
          alt="Logo"
          className="brand-logo"
          onError={(e) => (e.currentTarget.style.display = "none")}
        />
        <span className="brand-name">Alkeme UX</span>
      </div>

      <nav className="tabs" role="tablist" aria-label="Main tabs">
        <button
          role="tab"
          aria-selected={tab === "landing"}
          className={`tab ${tab === "landing" ? "is-active" : ""}`}
          onClick={() => onSwitch("landing")}
        >
          Landing
        </button>

        <button
          role="tab"
          aria-selected={tab === "markets"}
          className={`tab ${tab === "markets" ? "is-active" : ""}`}
          onClick={() => onSwitch("markets")}
        >
          Markets
        </button>

        <button
          role="tab"
          aria-selected={tab === "products"}
          className={`tab ${tab === "products" ? "is-active" : ""}`}
          onClick={() => onSwitch("products")}
        >
          Products
        </button>
      </nav>
    </header>
  );
}